import { useState } from 'react';
import { db, auth } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';
import { ArrowLeft } from 'lucide-react'; // ← Ajouter import
import { useNavigate } from 'react-router-dom'; // ← Ajouter import

export default function Feedback() {
  const navigate = useNavigate(); // ← Ajouter
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await addDoc(collection(db, 'feedbacks'), {
        userId: auth.currentUser?.uid,
        email: auth.currentUser?.email,
        subject,
        message,
        createdAt: new Date(),
        status: 'nouveau',
      });

      alert('Feedback envoyé !');
      setSubject('');
      setMessage('');
    } catch (error) {
      alert('Erreur: ' + error.message);
    }
    setLoading(false);
  };

  return (
    <div className="max-w-2xl mx-auto p-6">
      {/* Bouton retour */}
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4"
      >
        <ArrowLeft className="w-5 h-5" />
        Retour
      </button>

      <h1 className="text-3xl font-bold mb-6">Feedback</h1>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-2">Sujet</label>
          <select
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className="w-full p-3 border rounded-lg"
            required
          >
            <option value="">Sélectionner...</option>
            <option value="bug">🐛 Bug</option>
            <option value="ia">🤖 Comportement IA</option>
            <option value="suggestion">💡 Suggestion</option>
            <option value="question">❓ Question</option>
            <option value="autre">📝 Autre</option>
          </select>
        </div>

        <div>
          <label className="block mb-2">Message</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="w-full p-3 border rounded-lg h-40"
            placeholder="Décrivez votre feedback..."
            required
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? 'Envoi...' : 'Envoyer'}
        </button>
      </form>
    </div>
  );
}
